/**
 * Cart store using Zustand - Supports multiple stores
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCartStore = create(
  persist(
    (set, get) => ({
      items: [], // Each item has: { product, quantity, storeSlug, storeName }
      
      addItem: (product, storeSlug, storeName) => {
        const items = get().items;
        const existingItem = items.find(item => item.product.id === product.id);
        
        if (existingItem) {
          set({
            items: items.map(item =>
              item.product.id === product.id
                ? { ...item, quantity: item.quantity + 1 }
                : item
            )
          });
        } else {
          set({
            items: [...items, { 
              product, 
              quantity: 1,
              storeSlug: storeSlug || product.store_slug,
              storeName: storeName || product.store_name
            }]
          });
        }
      },
      
      removeItem: (productId) => {
        set({
          items: get().items.filter(item => item.product.id !== productId)
        });
      },
      
      updateQuantity: (productId, quantity) => {
        if (quantity <= 0) {
          get().removeItem(productId);
          return;
        }
        
        set({
          items: get().items.map(item =>
            item.product.id === productId
              ? { ...item, quantity }
              : item
          )
        });
      },
      
      clearCart: () => {
        set({ items: [] });
      },
      
      getTotal: () => {
        const items = get().items;
        return items.reduce((total, item) => 
          total + (item.product.price * item.quantity), 0
        );
      },
      
      getItemCount: () => {
        return get().items.reduce((count, item) => count + item.quantity, 0);
      },
      
      // Group items by store
      getItemsByStore: () => {
        const items = get().items;
        const grouped = {};
        
        items.forEach(item => {
          const storeSlug = item.storeSlug || 'default';
          if (!grouped[storeSlug]) {
            grouped[storeSlug] = {
              storeName: item.storeName || 'متجر',
              storeSlug: storeSlug,
              items: []
            };
          }
          grouped[storeSlug].items.push(item);
        });
        
        return grouped;
      },
      
      // Get total per store
      getTotalByStore: (storeSlug) => {
        const items = get().items.filter(item => item.storeSlug === storeSlug);
        return items.reduce((total, item) => 
          total + (item.product.price * item.quantity), 0
        );
      }
    }),
    {
      name: 'cart-storage',
    }
  )
);

export default useCartStore;
